"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProjectList = void 0;

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _atOffice = _interopRequireDefault(require("../../../assets/img/at-office.svg"));

var _ProjectListItem = _interopRequireDefault(require("../ProjectListItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '100%'
    },
    item: {
      marginBottom: theme.spacing(4)
    },
    loader: {
      width: '100%',
      minHeight: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column'
    }
  };
});

var EmptyProjectList = function EmptyProjectList() {
  var classes = useStyles();

  var _useTranslation = (0, _reactI18next.useTranslation)('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.loader
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _atOffice.default,
    alt: "no-projects"
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6"
  }, t('projects.noProjects')));
};

var ProjectList = function ProjectList(_ref) {
  var projects = _ref.projects,
      onProjectSelect = _ref.onProjectSelect,
      props = _objectWithoutProperties(_ref, ["projects", "onProjectSelect"]);

  var classes = useStyles();

  if (!projects || !projects.length) {
    return /*#__PURE__*/_react.default.createElement(EmptyProjectList, null);
  }

  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2,
    className: classes.root
  }, projects.map(function (_ref2) {
    var id = _ref2.id,
        props = _objectWithoutProperties(_ref2, ["id"]);

    return /*#__PURE__*/_react.default.createElement(_ProjectListItem.default, _extends({
      key: id,
      className: classes.item
    }, props, {
      projectId: id,
      onProjectSelect: onProjectSelect
    }));
  }));
};

exports.ProjectList = ProjectList;
ProjectList.propTypes = {
  projects: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    title: _propTypes.default.string.isRequired,
    description: _propTypes.default.string,
    companyName: _propTypes.default.string
  })),
  onProjectSelect: _propTypes.default.func
};
var _default = ProjectList;
exports.default = _default;